import { Menu, ShieldCheck } from 'lucide-react';
import { useLocation } from 'react-router-dom';

const titles = [
  ['/users/', 'جزئیات کاربر'],
  ['/users', 'کاربران'],
  ['/discounts', 'کدهای تخفیف'],
  ['/migrationdashboard', 'انتقال داده'],
  ['/', 'داشبورد'],
];

export default function Topbar({ onMenu }) {
  const { pathname } = useLocation();
  const title =
    titles.find(([path]) =>
      path === '/' ? pathname === '/' : pathname.startsWith(path)
    )?.[1] || 'پنل مدیریت';

  return (
    <header
      dir="rtl"
      className="fixed inset-x-0 top-0 z-40 h-[4.75rem] border-b border-[#1c2c29]/10 bg-[#f3efe7]/88 px-4 backdrop-blur-xl lg:right-[17.5rem]">
      <div className="mx-auto flex h-full max-w-[1320px] items-center justify-between">
        <div className="flex items-center gap-3">
          <button
            onClick={onMenu}
            className="flex h-10 w-10 items-center justify-center rounded-xl border border-[#1c2c29]/10 bg-white/65 lg:hidden">
            <Menu size={20} />
          </button>
          <div>
            <p className="admin-kicker hidden sm:block">AZI CONTROL CENTER</p>
            <h1 className="text-base font-black text-[#1c2c29]">{title}</h1>
          </div>
        </div>
        <div className="hidden items-center gap-2 rounded-xl border border-[#1c2c29]/10 bg-white/55 px-3 py-2 sm:flex">
          <ShieldCheck size={16} className="text-[#df6b52]" />
          <span className="text-xs font-bold text-[#52605b]">مدیریت</span>
        </div>
      </div>
    </header>
  );
}
